'use client';

import * as React from 'react';
import { ChakraProvider, defaultSystem } from '@chakra-ui/react';

import { tmsSystem } from './theme';
// Color mode provider removed in Chakra UI v3 - use next-themes instead

export interface UIProviderProps {
  children: React.ReactNode;
}

/**
 * UIProvider - Chakra UI v3 Provider for TMS
 *
 * NOTE: This component should be used with dynamic import (ssr: false) in Next.js
 * to prevent hydration mismatch errors. See apps/web/src/app/providers.tsx
 *
 * The suppressHydrationWarning wrapper was removed because:
 * 1. It doesn't prevent the hydration error (only suppresses text content warnings)
 * 2. With dynamic import ssr:false, there's no hydration to mismatch
 */
export function UIProvider({ children }: UIProviderProps) {
  return <ChakraProvider value={tmsSystem ?? defaultSystem}>{children}</ChakraProvider>;
}

// Export as Provider for backward compatibility
export const Provider = UIProvider;

// Re-export the theme system for external use
export { tmsSystem as system } from './theme';
